import {
  BsPerson,
  BsFileEarmarkSpreadsheet,
  BsHouseDoor,
} from "../../assets/icons/vander";
import { TopHeader } from "../components/utils";
import { PatientSurgeryTable } from "../components/tables";
import { PatientSurgerySearchForm } from "../components/forms";
import { DailyAssessmentCard, IndicatorsCard } from "../components/cards";
import { DashboardCalendar } from "../components/calendars";
import { DoctorLayout } from "../layout";

const Nav = () => {
  return (
    <nav aria-label="breadcrumb" className="d-inline-block">
      <ul className="breadcrumb bg-transparent rounded mb-0 p-0">
        <li className="breadcrumb-item active" aria-current="page">
          <BsHouseDoor className="icons-sm" /> Dashboard
        </li>
      </ul>
    </nav>
  );
};

export const MainPage = () => {
  return (
    <DoctorLayout>
      <TopHeader Nav={Nav} />

      <div className="row gy-3">
        <div className="col-12 col-xl-7 col-xxl-8">
          <h1>Dashboard</h1>
          <div className="row row-cols-1 row-cols-sm-2 row-cols-xxl-3 gy-3">
            <div className="col">
              <IndicatorsCard
                title={"Valoraciones"}
                number={12}
                icon={<BsFileEarmarkSpreadsheet className="icons" />}
              />
            </div>
            <div className="col">
              <IndicatorsCard
                title={"Pacientes"}
                number={54}
                icon={<BsPerson className="icons" />}
              />
            </div>
            <div className="col">
              <IndicatorsCard
                title={"Valoraciones"}
                number={12}
                icon={<BsFileEarmarkSpreadsheet className="icons" />}
              />
            </div>
          </div>
        </div>
        <div className="col-12 col-xl-5 col-xxl-4">
          <DashboardCalendar />
        </div>
        <div className="col-12 col-xl-12 col-xxl-8">
          <h3>Pacientes</h3>
          <div className="d-flex flex-column gap-3">
            <PatientSurgerySearchForm />
            <PatientSurgeryTable />
          </div>
        </div>
        <div className="col-12 col-xl-12 col-xxl-4">
          <DailyAssessmentCard />
        </div>
      </div>
    </DoctorLayout>
  );
};
